export default "__VITE_ASSET__8f46fc60__"